import request from './request';

/**
 * 测试计划API - V2
 * 支持评估目标和用例-快照配置
 */

// 获取可用的评估目标列表
export function getEvalTargets() {
  return request({
    url: '/eval/test-plans/eval-targets',
    method: 'get'
  });
}

// 创建测试计划
export function createTestPlan(data) {
  return request({
    url: '/eval/test-plans',
    method: 'post',
    data
  });
}

// 获取测试计划列表
export function getTestPlans(params) {
  return request({
    url: '/eval/test-plans',
    method: 'get',
    params
  });
}

// 获取测试计划详情
export function getTestPlanDetail(id) {
  return request({
    url: `/eval/test-plans/${id}`,
    method: 'get'
  });
}

// 更新测试计划
export function updateTestPlan(id, data) {
  return request({
    url: `/eval/test-plans/${id}`,
    method: 'put',
    data
  });
}

// 删除测试计划
export function deleteTestPlan(id) {
  return request({
    url: `/eval/test-plans/${id}`,
    method: 'delete'
  });
}

// 取消测试计划
export function cancelTestPlan(id) {
  return request({
    url: `/eval/test-plans/${id}/cancel`,
    method: 'post'
  });
}

// ==================== 用例配置管理 ====================

// 获取测试计划的用例配置列表
export function getPlanCases(planId) {
  return request({
    url: `/eval/test-plans/${planId}/cases`,
    method: 'get'
  });
}

// 添加用例配置到测试计划
export function addPlanCase(planId, data) {
  return request({
    url: `/eval/test-plans/${planId}/cases`,
    method: 'post',
    data
  });
}

// 更新用例配置
export function updatePlanCase(caseId, data) {
  return request({
    url: `/eval/test-plans/cases/${caseId}`,
    method: 'put',
    data
  });
}

// 删除用例配置
export function deletePlanCase(caseId) {
  return request({
    url: `/eval/test-plans/cases/${caseId}`,
    method: 'delete'
  });
}

// ==================== 执行相关 ====================

// 准备执行任务列表（预览）
export function prepareExecutionTasks(id) {
  return request({
    url: `/eval/test-plans/${id}/prepare-tasks`,
    method: 'get'
  });
}

// 执行测试计划（异步启动）
export function executeTestPlan(id) {
  return request({
    url: `/eval/test-plans/${id}/execute`,
    method: 'post'
  });
}

// 获取执行状态（用于轮询）
export function getExecutionStatus(planId) {
  return request({
    url: `/eval/executions/plan/${planId}/status`,
    method: 'get'
  });
}

// 取消执行中的计划
export function cancelExecution(planId) {
  return request({
    url: `/eval/executions/plan/${planId}/cancel`,
    method: 'post'
  });
}

// ==================== 一致性分析 ====================

// 获取一致性分析结果
export function getConsistencyResults(planId) {
  return request({
    url: `/eval/analysis/consistency/${planId}`,
    method: 'get'
  });
}

// 获取一致性分析结果详情
export function getConsistencyResultDetail(resultId) {
  return request({
    url: `/eval/analysis/consistency/result/${resultId}`,
    method: 'get'
  });
}

// 手动触发一致性分析
export function triggerConsistencyAnalysis(planId) {
  return request({
    url: `/eval/analysis/consistency/${planId}/analyze`,
    method: 'post'
  });
}
